




















import { Vue, Prop, Component, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class BreadcrumbConfig extends Vue {
  public defaultHours = 1;
  public defaultMinutes = 0;

  @Prop()
  public value: any;

  @Watch('value', { immediate: true })
  public onValChange(): void {
    if (!this.value) {
      const defaultValue = {
        hours: this.defaultHours,
        minutes: this.defaultMinutes,
      };

      this.$emit('input', defaultValue);
    } else {
      // eslint-disable-next-line eqeqeq
      if (this.value.hours == undefined) {
        this.value.hours = this.defaultHours;
      }

      // eslint-disable-next-line eqeqeq
      if (this.value.minutes == undefined) {
        this.value.minutes = this.defaultMinutes;
      }
    }
  }
}
